export const getjQueryVersion = (): any => (window as any).jQuery?.fn?.jquery;
